import { isArray } from 'lodash';

import StatusBlock from '../../status-block/StatusBlock';
import { getWorstStatus, getStatusName } from '../../../utilities/StatusUtilities';

const problemSeverityMappings = {
    Degraded: 'yellow',
    Excessive: 'orange',
    Critical: 'red',
};

const getMeasurementStatus = (status) => {
    switch (status?.toLowerCase()) {
        case 'success':
            return 'green';
        case 'error':
            return 'red';
        default:
            return 'gray';
    }
};

export const problemSeverity = (str) => problemSeverityMappings[str] || str;

export function statusColumnFormatter(columnValue) {
    if (!columnValue) {
        return columnValue;
    }

    const statuses = isArray(columnValue) ? columnValue : Object.values(columnValue);
    // Problems come down with the status name rather than the color, so do a translation if
    //  this is a problems export
    return getStatusName(getWorstStatus(statuses.map(problemSeverity)));
}

export function statusColumnRenderer(row, column) {
    const status = column.mapper(row, column);
    const worst = problemSeverity(status?.worst);
    return <StatusBlock color={worst || 'gray'} />;
}

export function QuickStatusColumnRenderer(row, column) {
    const status = column.mapper(row, column);
    const color = getMeasurementStatus(status);
    return <StatusBlock color={color} />;
}
